const styles = {
	paddingX: 'sm:px-16 px-6',
	paddingY: 'sm:py-16 py-6',
	padding: 'sm:px-16 px-6 sm:py-16 py-10',

	heroHeadText:
		'font-extrabold text-primary lg:text-[72px] sm:text-[56px] xs:text-[44px] text-[36px] lg:leading-[1.1] tracking-tight',
	heroSubText:
		'text-muted font-normal lg:text-[20px] sm:text-[18px] xs:text-[16px] text-[15px] lg:leading-[32px] max-w-2xl',

	sectionHeadText:
		'text-primary font-bold md:text-[40px] sm:text-[36px] xs:text-[30px] text-[26px] tracking-tight',
	sectionSubText:
		'sm:text-[15px] text-[13px] text-accent font-semibold uppercase tracking-widest',
};

export { styles };
